import type { ColumnDef } from '@tanstack/react-table';

import type { DailyCost } from '@cobliteam/common-types';

import { currencyFormatter, numberFormatter } from '@cobliteam/maintenance/src/components/utils';
import { format } from '@cobliteam/utils/date';

import DataTable from '@cobliteam/ui-business/components/DataTable';

const columns: ColumnDef<DailyCost>[] = [
  {
    id: 'date',
    accessorKey: 'date',
    accessorFn: (row) => row.date,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={format(row.original.date)} />,
    meta: {
      name: 'Data',
    },
  },
  {
    id: 'drivers',
    size: 200,
    accessorKey: 'drivers',
    accessorFn: (row) => row.drivers.join(', '),
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={row.original.drivers.join(', ') || 'Nenhum associado'} />,
    meta: {
      name: 'Motoristas',
    },
  },
  {
    id: 'drivenDistanceInMeters',
    accessorKey: 'drivenDistanceInMeters',
    accessorFn: (row) => `${row.distanceDrivenInMeters} Km`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={numberFormatter.format(Math.floor(row.original.distanceDrivenInMeters * 10) / 10) + ' Km'} />,
    meta: {
      name: 'Kms rodados',
    },
  },
  {
    id: 'fuelCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.fuelCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.fuelCost)} />,
    meta: {
      name: 'Combustível',
    },
  },
  {
    id: 'correctiveCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.preventiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.preventiveMaintenanceCost)} />,
    meta: {
      name: 'Man. Preventiva',
    },
  },
  {
    id: 'preventiveCost',
    accessorKey: 'fuelCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.correctiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.correctiveMaintenanceCost)} />,
    meta: {
      name: 'Man. Corretiva',
    },
  },
  {
    id: 'totalCost',
    accessorKey: 'totalCost',
    accessorFn: (row) => `R$ ${currencyFormatter.format(row.fuelCost + row.preventiveMaintenanceCost + row.correctiveMaintenanceCost)}`,
    header: DataTable.Header,
    cell: ({ row }) => (
      <DataTable.Cell content={'R$ ' + currencyFormatter.format(row.original.fuelCost + row.original.preventiveMaintenanceCost + row.original.correctiveMaintenanceCost)} />
    ),
    meta: {
      name: 'Gasto',
    },
  },
];

export default columns;
